import useSWR from 'swr';
import client from 'utils/client';

const fetcher = (...args) => client.get(...args).then(res => res.data);

/**
 * Fetches the Category and Product Information for a given Slug
 * @param params {Object} - Object containing the Slug and the ElasticSearch Queries that should be
 *   passed to the URL Parameters.
 * @returns {{isLoading: boolean, isError: any, data: AxiosResponse<any>}}
 */
function useCategoryData(params) {
  const urlParams = new URLSearchParams(params).toString();

  const { data, error } = useSWR(`/api/category/get/?${urlParams}`, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  return {
    data,
    isLoading: !error && !data,
    isError: error
  };
}

export default useCategoryData;
